import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AddSubject() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [selectionType, setSelectionType] = useState('one');
  const focusInputRef = useRef(null);
  const location = useLocation();
  const currentPath = location?.pathname || '';

  const [formData, setFormData] = useState({
    name: '',
    subjectCode: '',
  });

  const [subjectObjectives, setSubjectObjectives] = useState([]);
  const [selectedObjectives, setSelectedObjectives] = useState([]);

  useEffect(() => {
    const fetchSubjectObjectives = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${apiUrl}/api/subject-objective/`, {
          headers: {
            Authorization: `${token}`,
          },
        });
        const options = res.data.subjectObjectives.map((obj) => ({
          value: obj.id,
          label: obj.objectiveName,
        }));
        setSubjectObjectives(options);
      } catch (err) {
        console.error('Failed to load subject objectives', err);
      }
    };

    fetchSubjectObjectives();

    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }

    focus();
    // eslint-disable-next-line
  }, []);

  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoaded(true);
    const token = localStorage.getItem('token');

    const payload = {
      ...formData,
      subjectObjectiveIds: selectedObjectives.map((obj) => obj.value),
    };

    axios
      .post(`${apiUrl}/api/subject`, payload, {
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        toast.success('Subject added successfully');
        setLoaded(false);
        setFormData({ name: '', subjectCode: '' });
        setSelectedObjectives([]);
        focus();
        if (selectionType === 'one' && currentPath === '/AddSubject') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/AddSubject') {
              navigate('/ListSubject');
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || 'Something went wrong');
        err.response?.status === 401 && navigate('/');
        setLoaded(false);
      });
  };

  return (
    <>
      <AdminLayout ac2="active" dr="true">
        <main id="main" className="main">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/ListSubject">View Subject</Link>
                </li>
                <li className="breadcrumb-item active">Add New Subject</li>
              </ol>
            </nav>
          </div>

          <section className="section col-lg-112">
            <div className="row">
              <div className="">
                <div className="card">
                  <div className="card-body mt-5 mx-3">
                    <form onSubmit={handleSubmit}>
                      <div className="container">
                        <div className="row row-cols-1">
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                ref={focusInputRef}
                                className="form-control"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Name"
                                required
                              />
                              <label className="form-label">
                                Subject Name{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="subjectCode"
                                value={formData.subjectCode}
                                onChange={handleChange}
                                placeholder="Subject Code"
                                required
                                min={1}
                              />
                              <label className="form-label">
                                Subject Code{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="mb-3">
                              <Select
                                isMulti
                                name="subjectObjectiveIds"
                                options={subjectObjectives}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select Subject Objectives"
                                value={selectedObjectives}
                                onChange={(selected) =>
                                  setSelectedObjectives(selected)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="d-flex justify-content-between">
                          <div className="p-2 mx-2 bd-highlight">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input recode-switch"
                                type="checkbox"
                                id="selectionSwitch"
                                checked={selectionType === 'many'}
                                onChange={() =>
                                  setSelectionType(
                                    selectionType === 'many' ? 'one' : 'many'
                                  )
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="selectionSwitch"
                              >
                                {selectionType === 'many'
                                  ? 'Many Subjects Add'
                                  : 'One Subject Add'}
                              </label>
                            </div>
                          </div>

                          <div className="p-2 mx-1 bd-highlight">
                            <button
                              type="button"
                              className="btn btn-primary px-3"
                              onClick={() => navigate(-1)}
                            >
                              <i className="bi bi-arrow-bar-left"></i> Back
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary px-4 mx-1"
                              disabled={loaded}
                            >
                              {loaded ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>{' '}
                                  Wait...
                                </>
                              ) : (
                                <>Save</>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <ToastContainer
                      position="top-center"
                      style={{ width: 'auto' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </AdminLayout>
    </>
  );
}
